import { mutationTypes, actionTypes, errorTypes, getterTypes } from '@/types';
import { uiComponents, uiStates } from '@/tools/viewState';

export default {
	state: {
		articleID: null,
		tourID: null,
		exhibitionID: null,
		close: null,
		noContentInteraction: false,
	},
	mutations: {
		/**
		 *
		 * @param {*} state
		 * @param { id } options id articleID of the content
		 */
		[mutationTypes.setContentModal](state, { articleID, exhibitionID, tourID, close, noContentInteraction }) {
			state.articleID = articleID;
			state.tourID = tourID;
			state.exhibitionID = exhibitionID;
			state.close = close;
			state.noContentInteraction = noContentInteraction;
		},
	},
	actions: {
		/**
		 *
		 * @param {*} store
		 * @param {exhhibitionID, articleID, buttons, close} options exhibitionID and articleID sets the content will be shown
		 * button Array of navigation buttons which will be rendered in the modal navigation bar
		 * close method will be called on close button
		 */
		[actionTypes.contentModalSet](
			{ getters, commit, dispatch },
			{ articleID, exhibitionID, tourID, buttons, noContentInteraction, close }
		) {
			const exhibtion = getters[getterTypes.exhibitions].find((ex) => ex.exhibitionID == exhibitionID);
			if (!exhibtion) {
				dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unknownExhibition) });
				return;
			}
			const article = exhibtion.articles.find((article) => article[0] === articleID);
			if (!article) {
				dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unknownArticle) });
				return;
			}
			commit(mutationTypes.setNavigation, { navigation: { modal: buttons ? buttons : [] } });
			commit(mutationTypes.setContentModal, { articleID, exhibitionID, tourID, close, noContentInteraction });
			commit(mutationTypes.viewStateSetUiState, {
				id: uiComponents.uiContent,
				uiState: uiStates.maximised,
			});
		},
		/**
		 * this action closes content Modal
		 * @param {} store
		 */
		[actionTypes.contentModalClose]({ commit }) {
			commit(mutationTypes.viewStateSetUiState, {
				id: uiComponents.uiContent,
				uiState: uiStates.hidden,
			});
		},
	},
};
